import { formatDate } from 'date-fns';
import { ImageWidget } from '../../../interfaces';
import { CalendarEventWidget } from '../../../interfaces/widgets';

export function transformImageWidget(widget: CalendarEventWidget, size: 'small' | 'large' = 'large'): ImageWidget {
  const description = widget.event_date ? formatDate(new Date(widget.event_date), 'MMM d') : '';
  return {
    size: size,
    title: widget.title || '',
    description: description || '',
    linkUrl: widget.link || '',
    imageUrl: widget.image_url || '',
  };
}
